<mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
</mat-progress-bar>
<div *ngIf="backgroundReport" class="mainDiv">
  <div class="reportsDiv">
    <div class="report">
      <mat-card style="padding: 0%">
        <mat-toolbar>Summary</mat-toolbar>
      </mat-card>
      <mat-card>
        <table class="reportTable">
          <tr>
            <th>Status <br></th>
            <td>:&nbsp;&nbsp;{{backgroundReport.status}}<br></td>
          </tr>
          <tr>
            <th>Package<br></th>
            <td>:&nbsp;&nbsp;{{backgroundReport.package}}<br></td>
          </tr>
          <tr>
            <th>Source <br></th>
            <td>:&nbsp;&nbsp;{{backgroundReport.source}}<br></td>
          </tr>
          <tr>
            <th>Created <br></th>
            <td>:&nbsp;&nbsp;{{backgroundReport.completed_at | date}}<br></td>
          </tr>
          <tr>
            <th>Completed <br></th>
            <td>:&nbsp;&nbsp;{{backgroundReport.created_at | date}}<br></td>
          </tr>
          <tr>
            <th>Expected Turn Around Time <br></th>
            <td>:&nbsp;&nbsp;{{backgroundReport.turnaround_time}}&nbsp; Days<br></td>
          </tr>
          <tr class="reportData">
          </tr>
        </table>

      </mat-card>
      <br>
    </div>

    <div class="report">
      <mat-card style="padding: 0%">
        <mat-toolbar>Address History
          <button mat-button color="accent" (click)="showAddresses = !showAddresses">
            Show {{showAddresses ? 'less' :'more'}}</button>
        </mat-toolbar>
      </mat-card>
      <!-- <mat-card class="addresses"> -->
      <mat-card style="padding: 0%;max-height: 195px; overflow-y: auto;">
        <!-- <div style="max-height: 180px; overflow-y: scroll;"> -->
        <mat-accordion *ngIf="!showAddresses">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span style="font-size: 14px;">
                  {{backgroundReport?.ssn_trace?.addresses[0].street}},&nbsp;{{backgroundReport?.ssn_trace?.addresses[0].city}},&nbsp;{{backgroundReport?.ssn_trace?.addresses[0].state}},&nbsp;{{backgroundReport?.ssn_trace?.addresses[0].county}},&nbsp;{{backgroundReport?.ssn_trace?.addresses[0].zipcode}}
                </span>&nbsp;&nbsp;<br><br>
                <!-- <span>County : {{backgroundReport.ssn_trace.addresses[0].county}}</span> -->
              </mat-panel-title>

            </mat-expansion-panel-header>
            <span>County : {{backgroundReport?.ssn_trace?.addresses[0].county}}</span>
            <span style="float:right">
              <FONT SIZE="-1" style="text-align: right">From &nbsp;
                {{backgroundReport?.ssn_trace?.addresses[0].from_date}}
                &nbsp; to &nbsp;
                {{backgroundReport?.ssn_trace?.addresses[0].to_date}}</FONT>
            </span>
          </mat-expansion-panel>

        </mat-accordion>

        <mat-accordion *ngIf="showAddresses">
          <mat-expansion-panel *ngFor="let address of backgroundReport.ssn_trace.addresses">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span style="font-size: 14px;">
                  {{address?.street}},&nbsp;{{address?.city}},&nbsp;{{address?.state}},&nbsp;{{address?.county}},&nbsp;{{address?.zipcode}}
                </span>&nbsp;&nbsp;<br><br>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <span>County : {{address.county}}</span>
            <span style="float:right">
              <FONT SIZE="-1" style="text-align: right">From &nbsp;{{address?.from_date}}&nbsp; to
                &nbsp;{{address?.to_date}}
              </FONT>
            </span>
          </mat-expansion-panel>
        </mat-accordion>
        <!-- </div> -->
      </mat-card>
      <!-- <br> -->

    </div>
  </div><br>
  <div class="packageDiv">
    <mat-card style="padding: 0%">
      <mat-toolbar>Reports</mat-toolbar>
    </mat-card>
    <mat-card>
      <div>
        <!-- <mat-list> -->
        <div class="package" *ngFor="let package of existingPackages">
          <mat-accordion>
            <!-- <mat-expansion-panel [style.border]="getBlockBorder(package?.data?.status)"> -->
            <mat-expansion-panel [style.background-color]="getBlockColor(package?.data?.status)">
              <mat-expansion-panel-header [style.background-color]="getBlockColor(package?.data?.status)">
                <mat-panel-title class="header">
                  <span [style.color]="gettextColor(package?.data?.status)"
                    style="font-size: 15px;">{{package.name}}</span> &nbsp;&nbsp;
                  <FONT SIZE="-1" style="font-size: 12px;" [style.color]="gettextColor(package?.data?.status)">{{package?.data?.created_at |
                    date}}</FONT>
                </mat-panel-title>
                <mat-panel-description>
                  <span *ngIf="package?.data" [style.color]="getChipColor(package?.data?.status)"
                    style="text-transform: uppercase">
                    [&nbsp;{{package?.data?.status}}&nbsp;]</span>
                  <span *ngIf="!package?.data" [style.color]="getChipColor(package?.data?.status)"
                    style="text-transform: uppercase">
                    [&nbsp;Pending&nbsp;]</span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <table class="reportTable">
                <tr>
                  <th>Created <br></th>
                  <td>:&nbsp;&nbsp;{{package.data.completed_at | date}}<br></td>
                </tr>
                <tr>
                  <th>Completed <br></th>
                  <td>:&nbsp;&nbsp;{{package.data.created_at | date}}<br></td>
                </tr>
                <tr *ngFor="let record of package.data.records">
                  <th>Registry <br></th>
                  <td>:&nbsp;&nbsp;{{record.registry}}<br></td>
                </tr>

              </table>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <!-- </mat-list> -->
        <div>
          <div></div>
        </div>
      </div>
    </mat-card>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/shared/components/case-background/case-background.component.html